export default __webpack_public_path__ + "static/media/courseDescriptionA.3b7cabba.png";